var configStore = {
  events: {}
};
function set(newValuesObject) {
  configStore = Object.assign({}, configStore, newValuesObject);
}
function get(key) {
  return key ? configStore[key] : configStore;
}
export default {
  get: get,
  set: set
};